export const RFetch = async (url: string, mtd: string = 'GET', data = {}) => {
    const toast = useToast()
    const config = useRuntimeConfig()
    const token = useCookie('_xloginsession')
    const headers = {
        Accept: 'application/json',
        Authorization: `Bearer ${token.value}`,
    }
    url = `${url}`
    // if (process.env.NODE_ENV === 'development') {
    //     url = `${config.public.api_url}/api${url}`
    // } else {
    //     const host = window.location.host
    //     const protocol = window.location.protocol
    //     url = `${protocol}//${host}/api${url}`
    // }
    if (!url.includes('http')) {
        url = `${config.public.api_url}/api${url}`
    }
    try {
        let res = null
        if (mtd === 'GET') {
            res = await $fetch(url, {
                method: mtd,
                headers,
            })
        } else {
            res = await $fetch(url, {
                method: mtd,
                headers,
                body: data,
            })
        }
        return {
            message: '',
            status: 'success',
            data: res,
        }
    } catch (error) {
        if (error?.response?.status) {
            toast.add({
                title: `${error?.response?.status} - ${error?.response?.statusText}`,
                description: url + ' - ' + error?.response?._data?.detail,
                color: 'neutral',
                icon: 'material-symbols:heart-broken',
            })
            return {
                status: 'error',
                message: `Error: ${error.response.statusText}`,
                code: error.response.status,
                icon: 'material-symbols:heart-broken',
            }
        } else {
            return {
                status: 'error',
                message: `Error: ${error.response.statusText}`,
                icon: 'material-symbols:heart-broken',
                code: error.response.status,
            }
        }
    }
}

/*
+++++++++++++++++++
sample:
+++++++++++++++++++

<template lang="pug">
.w-full
    pre.p-3.text-sm.bg-neutral-900.text-white(
        class="min-h-dvh max-h-dvh overflow-y-auto"
        ref="logArea"
    )
        slot(
            v-for="a in store.messageValue"
        )
            | {{ a }}
            br
            //- | {{ JSON.parse(a).record?.level?.name }} - {{ JSON.parse(a).record?.time?.repr }} - {{ JSON.parse(a).text }}
</template>

<script setup lang="ts">
const logArea = ref(null)
const store = useSystemStore()

onMounted(() => {
    logArea.value.scrollTop = logArea.value.scrollHeight;
})

const onScroll = () => {
    const element = logArea.value
    logArea.value.scrollTop = element.scrollHeight;
}

watch(
    () => store.messageValue,
    () => {
        nextTick(() => onScroll())
    },
    { deep: true }
)


onMounted(async () => {
    try {
        await RSFetch(
            '/app_sempak/stream/12'
        )
    } catch (error) {
        console.error("Error fetching stream:", error);
    }

})
</script>
*/
